import { Box, Grid, Skeleton } from '@mui/material';
import { MediaQuery } from 'app/layout/MediaQuery';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  root: {
    paddingBottom: '36px',
  },
}));

export const PlacementSummaryTabLoaded = () => {
  const { classes } = useStyles();


  const LoadingComponent = ({ sx }) => {
    return (
      <Box sx={sx}>
        <Skeleton sx={{ height: '45px' }} />
      </Box>
    );
  }

  return (
    <Grid container spacing={2} className={classes.root} alignItems="flex-start">
        <Grid item xs={8} lg={6}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
            <LoadingComponent sx={{ marginY: 0 }}/>
            </Grid>
            <Grid item xs={12}>
              <LoadingComponent sx={{ marginY: 0 }}/>
            </Grid>
            <Grid item xs={12}>
              <LoadingComponent sx={{ marginY: 0 }}/>
            </Grid>
            <Grid item xs={12}>
              <LoadingComponent sx={{ marginY: 0 }}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4} lg={3}>
          <Grid container spacing={2}>
            <MediaQuery maxWidth="md">
            <Grid item xs={12}>
                  <LoadingComponent sx={{ marginY: 0 }}/>
                </Grid>
              
              <Grid item xs={12}>
              <Skeleton sx={{ marginY: 0 }} />
              </Grid>
              <Grid item xs={12}>
              <Skeleton sx={{ marginY: 0 }} />
              </Grid>
            </MediaQuery>

            <Grid item xs={12}>
            <LoadingComponent sx={{ marginY: 0 }}/>
            </Grid>
            <Grid item xs={12}>
            <LoadingComponent sx={{ marginY: 0 }}/>
            </Grid>
            <Grid item xs={12}>
                <LoadingComponent sx={{ marginY: 0 }}/>
              </Grid>
            <Grid item xs={12}>
              <LoadingComponent sx={{ marginY: 0 }}/>
            </Grid>
          </Grid>
        </Grid>

        <MediaQuery minWidth="lg">
          <Grid item lg={3}>
            <Grid container spacing={2}>
            <Grid item xs={12}>
                  <Skeleton sx={{ marginY: 0, marginTop: 1 }} />
                </Grid>
              <Grid item xs={12}>
              <Skeleton sx={{ marginY: 0 }} />
              </Grid>
              <Grid item xs={12}>
                <Skeleton sx={{ marginY: 0 }} />
              </Grid>
            </Grid>
          </Grid>
        </MediaQuery>
      </Grid>
  );
};
